import { QueryClient } from "@tanstack/react-query";

import { CompanyLeadSubscriptionsQuery } from "lib/generated/app-service-gql/graphql";

export const COMPANY_LEAD_SUBSCRIPTIONS_KEY = ["companyLeadSubscriptions"];

type CompanyLeadSubscription = CompanyLeadSubscriptionsQuery["companyLeadSubscriptions"][number];

// Insert-or-replace a company (Slack/Teams) subscription in the cached query result, so
// create/update mutations reflect immediately without a refetch. No-op if the query hasn't
// been fetched yet (the list will fetch fresh when it next mounts).
export function upsertCompanyLeadSubscription(
  queryClient: QueryClient,
  subscription: CompanyLeadSubscription,
): void {
  queryClient.setQueryData<CompanyLeadSubscriptionsQuery>(
    COMPANY_LEAD_SUBSCRIPTIONS_KEY,
    (current) => {
      if (!current) return current;
      const exists = current.companyLeadSubscriptions.some((s) => s.id === subscription.id);
      return {
        companyLeadSubscriptions: exists
          ? current.companyLeadSubscriptions.map((s) =>
              s.id === subscription.id ? subscription : s,
            )
          : [...current.companyLeadSubscriptions, subscription],
      };
    },
  );
}

export function removeCompanyLeadSubscription(queryClient: QueryClient, id: string): void {
  queryClient.setQueryData<CompanyLeadSubscriptionsQuery>(
    COMPANY_LEAD_SUBSCRIPTIONS_KEY,
    (current) =>
      current
        ? { companyLeadSubscriptions: current.companyLeadSubscriptions.filter((s) => s.id !== id) }
        : current,
  );
}
